import { useMemo } from 'react';
import { useHistory, useRouteMatch, useLocation, useParams } from 'react-router-dom';

export function useRouter(matcher) {
    const history = useHistory();
    const match = useRouteMatch(matcher);
    const location = useLocation();
    const params = useParams();

    return useMemo(() => {
        return {
            push: history.push,
            replace: history.replace,
            pathname: location.pathname,
            query: new URLSearchParams(location.search),
            match,
            location,
            history,
            params
        };
    }, [params, match, location, history]);
}